<app-dialog-container
  title="discardChangesQuestion"
  [showCancelButton]="false"
  [showConfirmButton]="false"
>
  <p class="message">{{ 'unsavedChangesWillBeLost' | translate }}</p>
  <div class="actions">
    <app-ui-button
      buttonType="secondary"
      text="{{ 'keepEditing' | translate }}"
      [mat-dialog-close]="false"
    ></app-ui-button>
    <app-ui-button
      color="warn"
      text="{{ 'discardChanges' | translate }}"
      [mat-dialog-close]="true"
    ></app-ui-button>
  </div>
</app-dialog-container>
